/* eslint-disable no-restricted-syntax */

import ui from './ui';
import pageTitle from './pageTitle';
import language from './language';
import form from './form';
import properNouns from './properNouns';
import errors from './errors';
import crm from './crm';
import sider from './sider';
import info from './info';

export default{
  ui,
  pageTitle,
  language,
  form,
  properNouns,
  errors,
  crm,
  sider,
  info,
};



// WEBPACK FOOTER //
// ./src/i18n/global/index.js